
import { X } from "lucide-react";
import { useIOSDetection } from "@/hooks/use-ios-detection";

interface CloseButtonProps {
  onClose: () => void;
}

export function CloseButton({ onClose }: CloseButtonProps) {
  const isIOS = useIOSDetection();
  
  return (
    <button
      onClick={onClose}
      className="absolute z-50 w-10 h-10 flex items-center justify-center text-white/80 hover:text-white bg-white/10 hover:bg-white/15 backdrop-blur-[20px] border border-white/20 rounded-full transition-all duration-200 cursor-pointer outline-none focus:outline-none focus:ring-0"
      style={{
        top: isIOS ? 'calc(env(safe-area-inset-top) + 1.5rem + 10px)' : 'calc(1.5rem + 10px)',
        right: '0.75rem'
      }}
    >
      <X className="w-5 h-5" />
    </button>
  );
}
